var StepService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ApiWorkflowConstants } from "../shared/constants/api-constants/api-workflow.constants";
import { ApiTimeoutConstants } from "../shared/constants/api-constants/api-timeout.constants";
import { ApiChecklistConstants } from "../shared/constants/api-constants/api-checklist.constants";
import { ApiRequiredDocumentsChecklistConstants } from "../shared/constants/api-constants/api-required-documents-checklist.constants";
import { ApiRecipientConstants } from "../shared/constants/api-constants/api-recipient.constants";
import { map } from "rxjs/operators";
import { ApiAvailableSurveyConstants } from "../shared/constants/api-constants/api-available-survey.constants";
import { TrueCentroidResultsModel } from "../shared/models/gpserver-truecentroid-model";
import { ApiSetFieldConstants } from "../shared/constants/api-constants/api-set-field.constants";
import { ApiInvoiceConstants } from "../shared/constants/api-constants/api-invoice.constants";
import { ApiCemeteryConstants } from "../shared/constants/api-constants/api-cemetery.constants";
import { ApiConditionConstants } from "../shared/constants/api-constants/api-condition.constants";
import { ApiArcgisItemsConstants } from "../shared/constants/api-constants/api-arcgis-items.constants";
import { ApiLookupConstants } from "../shared/constants/api-constants/api-lookup.constants";
import { ApiCloseoutConstants } from "../shared/constants/api-constants/api-closeout.constants";
import { ApiAdminConstants } from "../shared/constants/api-constants/api-admin.constants";
import { ApiPropertyValuationValuationBlockConstants } from "../shared/constants/api-constants/api-property-valuation-valuation-block.constants";
import { ApiPropertyValuationValuationBlockSurveyPropertiesConstant } from "../shared/constants/api-constants/api-property-valuation-valuation-block-survey-properties.constant";
import { ApiCommunicationConstants } from "../shared/constants/api-constants/api-communication.constants";
import { ApiPropertyValuationValuationProperty } from "../shared/constants/api-constants/api-property-valuation-property";
import { ApiPropertyValuationPropertyConstants } from "../shared/constants/api-constants/api-property-valuation-proprety.constants";
import { ApiEhmsConstants } from "../shared/constants/api-constants/api-ehms.constants";
import { ApiPropertyValuationValuationPropertyAppealConstants } from "../shared/constants/api-constants/api-property-valuation-property-appeal";
import { ApiPropertyValuationPropertyObjection } from "../shared/constants/api-constants/api-property-valuation-property-objection.constant";
import { ApiPropertyValuationValuation } from "../shared/constants/api-constants/api-property-valuation-valuation.constant";
import { ApiAttachmentConstants } from "../shared/constants/api-constants/api-attachment.constants";
import { ApiPropertyValuationCalculations } from "../shared/constants/api-constants/api-property-valuation-calculation.constant";
import { ApiEhInspectionSurveyConstants } from "../shared/constants/api-constants/api-eh-inspection-survey.constants";
import { ApiEhInspectionConstants } from "../shared/constants/api-constants/api-eh-inspection.constants";
import { ApiEhInspectionActionTypeSurveyConstants } from "../shared/constants/api-constants/api-eh-inspection-action-type-survey.constants";
import { ApiEhPremiseConstants } from "../shared/constants/api-constants/api-eh-premise.constants";
import { UrlParameterEncodingCodec } from "../shared/classes/url-parameter-encoding-codec";
import { ApiCommentsConstants } from "../shared/constants/api-constants/api-comments.constants";
import { ApiPropertyValuationprojectCycleSurveysConstants } from "../shared/constants/api-constants/api-property-valuation-project-cycle-surveys.constants";
import { ApiSurvey123Constants } from "../shared/constants/api-constants/api-survey-123.constants";
import { ApiAuthoriseConstants } from "../shared/constants/api-constants/api-authorise.constants";
import { ApiTeamConstants } from "../shared/constants/api-constants/api-team.constants";
import { ApiEditableSurvey123Constants } from "../shared/constants/api-constants/api-editable-survey-123.constants";
import { ApiModuleNotificationTemplateConstants } from "../shared/constants/api-constants/api-module-notification-template.constants";
import { ApiModuleRoleConstants } from "../shared/constants/api-constants/api-module-role.constants";
import { ApiStepManagementConstants } from "../shared/constants/api-constants/api-step-management.constants";
import { ApiEscalationsConstants } from "../shared/constants/api-constants/api-escalations.constants";
import { ApiRequestCommentsConstants } from "../shared/constants/api-constants/api-request-comments.constants";
let StepService = class StepService {
    static { StepService_1 = this; }
    http;
    static URL_PARAMETER_ENCODING_CODEC = new UrlParameterEncodingCodec();
    constructor(http) {
        this.http = http;
    }
    getRequiredDocumentChecklistsMarkAsCompletedObservable(params) {
        return this.http.post(ApiRequiredDocumentsChecklistConstants.URL + "/" + ApiRequiredDocumentsChecklistConstants.FUNCTION_MARK_AS_COMPLETED, params);
    }
    getRequiredDocumentRequestOutstandingDocumentsObservable(params) {
        return this.http.post(ApiRequiredDocumentsChecklistConstants.URL + "/" + ApiRequiredDocumentsChecklistConstants.FUNCTION_REQUEST_OUTSTANDING_DOCUMENTS, params);
    }
    getRequiredDocumentChecklistsMarkAsNotCompleteObservable(params) {
        return this.http.post(ApiRequiredDocumentsChecklistConstants.URL + "/" + ApiRequiredDocumentsChecklistConstants.FUNCTION_MARK_AS_NOT_COMPLETE, params);
    }
    getChecklistsObservable(params) {
        return this.http.get(ApiChecklistConstants.URL, { params });
    }
    getChecklistMarkAsCompletedObservable(params) {
        return this.http.post(ApiChecklistConstants.URL + "/" + ApiChecklistConstants.FUNCTION_MARK_AS_COMPLETED, params);
    }
    getChecklistMarkAsNotCompleteObservable(params) {
        return this.http.post(ApiChecklistConstants.URL + "/" + ApiChecklistConstants.FUNCTION_MARK_AS_NOT_COMPLETE, params);
    }
    getStepSaveObservable(currentStep, params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_SAVE + currentStep.type.replace(" ", ""), params);
    }
    getStepContinueObservable(currentStep, params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_CONTINUE + currentStep.type.replace(" ", ""), params);
    }
    getStopTimeoutTimersObservable(jobId, params) {
        return this.http.get(`${ApiTimeoutConstants.URL}/${jobId}/${ApiTimeoutConstants.FUNCTION_GET_STOP_TIMEOUT_TIMERS}`, { params });
    }
    getAwaitTimersObservable(jobId, params) {
        const encodedParams = new HttpParams({
            fromObject: params, encoder: StepService_1.URL_PARAMETER_ENCODING_CODEC
        });
        return this.http.get(`${ApiTimeoutConstants.URL}/${jobId}/${ApiTimeoutConstants.FUNCTION_GET_AWAIT_TIMEOUT_TIMERS}`, { params: encodedParams });
    }
    getRecipientFromTableAndFieldObservable(params) {
        return this.http.get(`${ApiRecipientConstants.URL}/${ApiRecipientConstants.FUNCTION_GET_RECIPIENT_FROM_TABLE_AND_FIELD}`, { params });
    }
    getRecipientsObservable(params) {
        return this.http.get(ApiRecipientConstants.URL, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getRecipientsByGroup(params) {
        return this.http.post(`${ApiRecipientConstants.URL}/${ApiRecipientConstants.FUNCTION_GET_RECIPIENTS_BY_GROUP}`, params);
    }
    getArcGisItemsObservable(params) {
        return this.http.get(ApiArcgisItemsConstants.URL, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getLookupsObservable(params) {
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getConditionsObservable(params) {
        return this.http.get(ApiConditionConstants.URL, { params });
    }
    logExternalCommunication(communication, jobId, stepName, stepId) {
        const request = {
            communication,
            jobId,
            stepName,
            stepId
        };
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_LOG_COMMUNICATION}`, request)
            .pipe(map(response => {
            return response;
        }));
    }
    getAvailableSurveys(params) {
        return this.http.get(ApiAvailableSurveyConstants.URL, { params }).pipe(map(availableSurveys => {
            return availableSurveys;
        }));
    }
    getEditableSurvey123(params) {
        return this.http.get(ApiEditableSurvey123Constants.URL, { params }).pipe(map(surveys => {
            return surveys;
        }));
    }
    getOrCreateEditableSurvey123(params) {
        return this.http.post(`${ApiEditableSurvey123Constants.URL}/${ApiEditableSurvey123Constants.FUNCTION_GET_CREATE_EDITABLE_SURVEY_123S}`, params).pipe(map(surveys => {
            return surveys;
        }));
    }
    captureCommentReview(review) {
        return this.http.post(`${ApiCommentsConstants.URL}/SetReviewStatusForComment`, review);
    }
    captureCommentSaveComment(params) {
        return this.http.post(`${ApiCommentsConstants.URL}`, params).pipe(map((response) => {
            return response;
        }));
    }
    getModuleNotificationTemplatesObservable(params) {
        return this.http.get(`${ApiModuleNotificationTemplateConstants.URL}`, { params }).pipe(map(result => {
            return result.value;
        }));
    }
    getModuleRoleAndUsersObservable(params) {
        return this.http.get(`${ApiModuleRoleConstants.URL}/${ApiModuleRoleConstants.FUNCTION_GET_MODULE_ROLES_AND_USERS}`, { params }).pipe(map(result => {
            return result.value;
        }));
    }
    getResponsiblePersonsObservable(params) {
        return this.http.post(`${ApiTeamConstants.URL}/${ApiTeamConstants.FUNCTION_GET_RESPONSIBLE_PERSONS}`, params).pipe(map(response => {
            return response.value;
        }));
    }
    getRequestComment(params) {
        const url = `${ApiRequestCommentsConstants.URL}`;
        return this.http.get(url, { params }).pipe(map(requestComment => {
            return requestComment;
        }));
    }
    getOrCreateRequestComment(params) {
        const url = `${ApiRequestCommentsConstants.URL}/${ApiRequestCommentsConstants.FUNCTION_GET_REQUEST_COMMENTS}`;
        return this.http.get(url, { params }).pipe(map(requestComment => {
            return requestComment;
        }));
    }
    updateRequestCommentStatus(params) {
        const url = `${ApiRequestCommentsConstants.URL}/${ApiRequestCommentsConstants.FUNCTION_UPDATE_REQUEST_COMMENT_STATUS}`;
        return this.http.get(url, { params }).pipe(map(requestComment => {
            return requestComment;
        }));
    }
    getLocationData(key, params) {
        const url = `${ApiAvailableSurveyConstants.URL}/${key}/${ApiAvailableSurveyConstants.FUNCTION_GET_LOCATION_DATA}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            return response;
        }));
    }
    getTrueCentroid(url, params) {
        return this.http.post(url, params).pipe(map((response) => {
            return new TrueCentroidResultsModel().deserialize(response);
        }));
    }
    getSetFieldsObservable(params) {
        return this.http.get(`${ApiSetFieldConstants.URL}/${ApiSetFieldConstants.FUNCTION_GET_VALUES}`, { params });
    }
    getApplicationTeam(params) {
        return this.http.get(`${ApiTeamConstants.URL}`, { params });
    }
    getApplicationTeamUserRoles(jobId, params) {
        return this.http.get(`${ApiTeamConstants.URL}/${jobId}/${ApiTeamConstants.FUNCTION_GET_APPLICATION_TEAM_USER_ROLES}`, { params });
    }
    getAuthorisationsObservable(params) {
        return this.http.get(`${ApiAuthoriseConstants.URL}`, { params }).pipe(map((data) => {
            return data.value;
        }));
    }
    getEscalationsObservable(params) {
        return this.http.get(`${ApiEscalationsConstants.URL}`, { params }).pipe(map((data) => {
            return data.value;
        }));
    }
    updateAuthorisationsObservable(authorisationObject) {
        return this.http.post(`${ApiAuthoriseConstants.URL}/${ApiAuthoriseConstants.FUNCTION_UPDATE_AUTHORISATION}`, authorisationObject).pipe(map((data) => {
            return data.value;
        }));
    }
    updateEscalationObservable(authorisationObject) {
        return this.http.post(`${ApiEscalationsConstants.URL}/${ApiEscalationsConstants.FUNCTION_UPDATE_ESCALATION}`, authorisationObject).pipe(map((data) => {
            return data.value;
        }));
    }
    createAuthorisationsObservable(params) {
        return this.http.post(`${ApiAuthoriseConstants.URL}/${ApiAuthoriseConstants.FUNCTION_SET_AUTHORISATION_ITEMS}`, params);
    }
    createEscalationsObservable(params) {
        return this.http.post(`${ApiEscalationsConstants.URL}/${ApiEscalationsConstants.FUNCTION_SET_ESCALATION_ITEMS}`, params);
    }
    getCloseout(params) {
        return this.http.get(ApiCloseoutConstants.URL, { params }).pipe(map((data) => {
            return data.value;
        }));
    }
    getInvoice(params) {
        return this.http.get(ApiInvoiceConstants.URL, { params }).pipe(map((data) => {
            return data.value;
        }));
    }
    verifyInvoice(params) {
        return this.http.post(ApiInvoiceConstants.URL, { params }).pipe(map((data) => {
            return data.value;
        }));
    }
    updateContactPersonAndPersonResponsible(invoiceObject) {
        const params = {
            contactPerson: invoiceObject.contactPerson, personResponsible: invoiceObject.personResponsible
        };
        return this.http.post(`${ApiInvoiceConstants.URL}/${invoiceObject.InvoiceId}/SetContactPersonAndPersonResponsible`, params);
    }
    updateInvoiceItems(invoiceObject) {
        const params = {
            invoiceItems: invoiceObject.InvoiceItems
        };
        return this.http.post(`${ApiInvoiceConstants.URL}/${invoiceObject.InvoiceId}/SetInvoiceItems`, params);
    }
    updateInvoice(invoiceObject) {
        const params = invoiceObject.invoice;
        return this.http.patch(`${ApiInvoiceConstants.URL}/${invoiceObject.InvoiceId}`, params);
    }
    unVerifyInvoice(invoiceId) {
        const params = {
            verified: "No",
        };
        return this.http.patch(`${ApiInvoiceConstants.URL}/${invoiceId}`, params);
    }
    getCMApplicationObservable(params) {
        return this.http.get(`${ApiCemeteryConstants.URL}`, { params });
    }
    setGraveStatus(params, applicationId) {
        return this.http.post(`${ApiCemeteryConstants.URL}/${applicationId}/SetGraveStatus`, params);
    }
    getJobInformationObservable(params) {
        return this.http.get(`${ApiAdminConstants.URL + "/" + ApiAdminConstants.FUNCTION_GET_JOB_INFORMATION}`, { params });
    }
    getEhApplicationObservable(params) {
        return this.http.get(`${ApiEhmsConstants.URL}`, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getEhInspectionsObservable(params) {
        return this.http.get(`${ApiEhInspectionConstants.URL}`, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getEhInspectionSurveysObservable(id) {
        return this.http.get(`${ApiEhInspectionSurveyConstants.URL}/${id}`);
    }
    getEhInspectionActionSurveysObservable(id) {
        return this.http.get(`${ApiEhInspectionActionTypeSurveyConstants.URL}/${id}/${ApiEhInspectionActionTypeSurveyConstants.FUNCTION_GET_ACTION_TYPE_SURVEYS_FOR_INSPECTION}`).pipe(map((response) => {
            return response.value;
        }));
    }
    getEhPremisesObservable(params) {
        return this.http.get(`${ApiEhPremiseConstants.URL}`, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getValuationBlockObservable(params) {
        return this.http.get(`${ApiPropertyValuationValuationBlockConstants.URL}`, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getPvImportHistory(params) {
        return this.http.get(`${ApiPropertyValuationValuationBlockConstants.URL}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_GET_IMPORT_HISTORY}`, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getPropertiesWithAppealsObservable(params) {
        return this.http
            .get(`${ApiPropertyValuationPropertyConstants.URL}`, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    getValuationBlockPropertyObservable(params) {
        return this.http.get(`${ApiPropertyValuationPropertyConstants.URL}`, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getValuationBlockPropertiesObservable(params) {
        return this.http.get(`${ApiPropertyValuationValuationBlockConstants.URL}`, { params }).pipe(map((data) => {
            const valBlockArray = data.value;
            return valBlockArray[0].properties;
        }));
    }
    getPvSurveyPropertiesObservable(jobId) {
        return this.http.get(`${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.URL}?key=${jobId}`);
    }
    acceptAppeal(appealId) {
        return this.http.post(`${ApiPropertyValuationValuationPropertyAppealConstants.URL}/${appealId}/${ApiPropertyValuationValuationPropertyAppealConstants.FUNCTION_ACCEPT_APPEAL}`, {});
    }
    rejectAppeal(appealId) {
        return this.http.post(`${ApiPropertyValuationValuationPropertyAppealConstants.URL}/${appealId}/${ApiPropertyValuationValuationPropertyAppealConstants.FUNCTION_REJECT_APPEAL}`, {});
    }
    acceptObjection(appealId) {
        return this.http.post(`${ApiPropertyValuationPropertyObjection.URL}/${appealId}/${ApiPropertyValuationPropertyObjection.FUNCTION_ACCEPT_OBJECTION}`, {});
    }
    rejectObjection(appealId) {
        return this.http.post(`${ApiPropertyValuationPropertyObjection.URL}/${appealId}/${ApiPropertyValuationPropertyObjection.FUNCTION_REJECT_OBJECTION}`, {});
    }
    getObjectionsObservable(params) {
        return this.http.get(`${ApiPropertyValuationPropertyObjection.URL}`, { params }).pipe(map(response => {
            return response.value;
        }));
    }
    getAppealsObservable(params) {
        return this.http.get(ApiPropertyValuationValuationPropertyAppealConstants.URL, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    getAttachmentContent(attachmentId) {
        return this.http.get(`${ApiAttachmentConstants.URL}/${attachmentId}/${ApiAttachmentConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`, { responseType: "blob" });
    }
    importMarketAnalysisData(valuationBlockId) {
        return this.http.post(`${ApiPropertyValuationValuationBlockConstants.URL}/${valuationBlockId}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_IMPORT_PV_BLOCK_DATA}`, {});
    }
    getPropertySurveyData(valuationBlockId, params) {
        return this.http.get(`${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.URL}?key=${valuationBlockId}`, { params }).pipe(map((response) => {
            return response.value[0];
        }));
    }
    setParentProperty(propertyId, parentPropertyId, parentPropertyRelationship) {
        return this.http.post(`${ApiPropertyValuationValuationProperty.URL}/${propertyId}/${ApiPropertyValuationPropertyConstants.FUNCTION_SET_PARENT_PROPERTY}`, { parentPropertyId, parentPropertyRelationship });
    }
    removeParentProperty(propertyId) {
        return this.http.post(`${ApiPropertyValuationValuationProperty.URL}/${propertyId}/${ApiPropertyValuationPropertyConstants.FUNCTION_REMOVE_PARENT_PROPERTY}`, {});
    }
    getPropertyValuationValuation(params) {
        return this.http.get(ApiPropertyValuationValuation.URL, { params }).pipe(map(response => {
            return response.value;
        }));
    }
    postHistoricValueCapture(id, value) {
        return this.http.post(`${ApiPropertyValuationValuation.URL}/${id}/${ApiPropertyValuationValuation.FUNCTION_HISTORIC_VALUE_CAPTURE}`, { value });
    }
    importCsvFile(fomData, key) {
        return this.http.post(`${ApiPropertyValuationValuation.URL}/${key}/${ApiPropertyValuationValuation.FUNCTION_CSV_HISTORIC_VALUE_CAPTURE}`, fomData);
    }
    /**
     * Calculates and saves the valuation of a property based on the valuation block id and property id.
     * This also returns the valuation data.
     * @param valuationBlockId - The valuation block id of the property.
     * @param propertyId - The id of the property.
     * @param acceptedType - The acceptedType of valuation. The type parameter is either 'block' or 'objection' or 'appeal'.
     */
    calculatePropertyValuation(valuationBlockId, propertyId, acceptedType) {
        return this.http.get(`${ApiPropertyValuationCalculations.URL}/${ApiPropertyValuationCalculations.FUNCTION_GET_VALUATIONS}?valuationBlockId=${valuationBlockId}&propertyId=${propertyId}&acceptedType=${acceptedType}`).pipe(map(response => {
            return response;
        }));
    }
    startAllValuationCalculations(moduleId, jobId, acceptedType) {
        const params = {
            moduleId, jobId, acceptedType
        };
        return this.http.post(`${ApiPropertyValuationCalculations.URL}/${ApiPropertyValuationCalculations.FUNCTION_START_ALL_VALUATION_CALCULATIONS}`, params);
    }
    /**
     * Accept the valuation.
     * @param valuationId Valuation id.
     * @param type The valuation type to accept. The type parameter is either 'block' or 'objection' or 'appeal'.
     */
    acceptValuation(valuationId, type) {
        return this.http.post(`${ApiPropertyValuationValuation.URL}/${valuationId}/${ApiPropertyValuationValuation.FUNCTION_ACCEPT_VALUATION}/?type=${type}`, {});
    }
    acceptMultipleValuations(params, type) {
        return this.http.post(`${ApiPropertyValuationValuation.URL}/${ApiPropertyValuationValuation.FUNCTION_ACCEPT_MULTIPLE_VALUATION}/?type=${type}`, params);
    }
    /**
     * Reject the valuation.
     * @param valuationId Valuation id.
     */
    rejectValuation(valuationId) {
        return this.http.post(`${ApiPropertyValuationValuation.URL}/${valuationId}/${ApiPropertyValuationValuation.FUNCTION_REJECT_VALUATION}`, {});
    }
    postPvValuation(obj) {
        return this.http.post(`${ApiPropertyValuationValuation.URL}/${ApiPropertyValuationValuation.FUNCTION_CREATE_VALUATION}`, obj);
    }
    getSetFieldsSequenceNumber(params) {
        return this.http.get(`${ApiSetFieldConstants.URL}/${ApiSetFieldConstants.FUNCTION_GET_SEQUENCE_NUMBER}`, { params });
    }
    postPvSurveyCheckIfData(params) {
        return this.http.post(`${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.URL}/${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.FUNCTION_CHECK_IF_PREVIOUS_FINAL_VALUATION_EXIST}`, params);
    }
    postPvSurveyImportFinalSurveyData(params) {
        return this.http.post(`${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.URL}/${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.FUNCTION_IMPORT_PREVIOUS_FINAL_VALUATION}`, params);
    }
    postPvSurveyImportFieldCard(params) {
        return this.http.post(`${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.URL}/${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.FUNCTION_IMPORT_FIELD_CARD}`, params);
    }
    postSurveyNotification(moduleId, jobId, surveyId) {
        return this.http.get(`${ApiSurvey123Constants.URL}/${ApiSurvey123Constants.FUNCTION_ADD_SURVEY_NOTIFICATION}?moduleId=${moduleId}&jobId=${jobId}&Id=${surveyId}`);
    }
    postPersonNotification(params) {
        return this.http.post(`${ApiSurvey123Constants.URL}/${ApiSurvey123Constants.FUNCTION_ADD_PERSON_NOTIFICATION}`, params);
    }
    getSalesDataByBlockID(params) {
        return this.http.get(`${ApiPropertyValuationValuation.URL}/${ApiPropertyValuationValuation.FUNCTION_GET_COMPARABLE_SALES_DATA}`, { params }).pipe(map(response => {
            return response;
        }));
    }
    getPvMaCpComparableSalesByBlockID(params) {
        return this.http.get(`${ApiPropertyValuationValuation.URL}/${ApiPropertyValuationValuation.FUNCTION_GET_PVMACP_COMPARABLE_SALES_DATA}`, { params }).pipe(map(response => {
            return response;
        }));
    }
    getValuationBlock(params) {
        return this.http.get(`${ApiPropertyValuationValuationBlockConstants.URL}`, { params }).pipe(map((data) => {
            const valBlockArray = data.value;
            return valBlockArray;
        }));
    }
    updateSalesData(params) {
        return this.http.post(`${ApiPropertyValuationValuation.URL}/${ApiPropertyValuationValuation.FUNCTION_UPDATE_COMPARABLE_SALES_DATA}`, params);
    }
    updatePvMaCpComparableSalesData(params) {
        return this.http.post(`${ApiPropertyValuationValuation.URL}/${ApiPropertyValuationValuation.FUNCTION_UPDATE_PVMACP_COMPARABLE_SALES_DATA}`, params);
    }
    getProjectCycleSurveys(params) {
        return this.http.get(ApiPropertyValuationprojectCycleSurveysConstants.URL, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    generatePvNotice(key, params) {
        return this.http.get(`${ApiPropertyValuationValuationBlockConstants.URL}/${key}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_GENERATE_PV_NOTICE}`, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    postMarkAllSurveysAsCompleted(params) {
        return this.http.post(`${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.URL}/${ApiPropertyValuationValuationBlockSurveyPropertiesConstant.FUNCTION_MARK_ALL_SURVEYS_AS_COMPLETED}`, params);
    }
    getVatPercentage() {
        return this.http.get(`${ApiInvoiceConstants.URL}/${ApiInvoiceConstants.GetVatPercentage}`).pipe(map((data) => {
            return data.value;
        }));
    }
    getStepManagementObservable(params) {
        return this.http.get(`${ApiStepManagementConstants.URL}`, { params }).pipe(map((data) => {
            return data.value;
        }));
    }
    sendSystemEmail(params) {
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_GENERATE_SYSTEM_EMAIL}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    downloadNotice(params) {
        const headers = new HttpHeaders({
            "Content-Type": "application/json",
            Accept: "application/json",
        });
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_DOWNLOAD_NOTICE}`, params, {
            headers, responseType: "blob",
        });
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
StepService = StepService_1 = __decorate([
    Injectable({
        providedIn: "root",
    })
], StepService);
export { StepService };
